<template>
  <q-intersection transition="slide-down" v-show="this.show">
    <q-table
      flat
      bordered
      :data="reports"
      row-key="id"
      :columns="columnsLocal"
      :pagination="pagination"
      :visible-columns="visibleColumns"
    >
      <template v-slot:top-left>
        <div class="row items-center">
          <div class="text-center q-mr-sm">{{ $t('sort_by') }}:</div>
          <q-select
            :label="$t('column')"
            v-model="sorting.column"
            style="min-width: 150px"
            outlined
            dense
            :options="columnsLocal.filter((item) => item.label != 'Índice')"
            clearable
          />
          <q-toggle
            :label="`${$t('ascending')} | ${$t('descending')}`"
            true-value="desc"
            false-value="asc"
            color="blue"
            v-model="sorting.order"
          />
          <q-btn class="q-ml-md" color="positive" no-caps unelevated @click="retrieveWithSorting">{{ $t('sort') }}</q-btn>
        </div>
      </template>
      <template v-slot:top-right>
        <q-btn
          outline
          color="grey-3"
          size="12px"
          text-color="grey-8"
          icon-right="archive"
          class="q-mr-sm q-py-xs"
          no-caps
          @click="exportClickReport()"
          unelevated
        >
          <q-tooltip> {{ $t('export_csv') }}</q-tooltip>
        </q-btn>
        <q-select
          v-model="visibleColumns"
          multiple
          outlined
          dense
          options-dense
          :display-value="$t('customize_columns')"
          emit-value
          map-options
          :options="columnsLocal"
          option-value="name"
          options-cover
          style="min-width: 150px"
        >
          <template v-slot:option="{ itemProps, itemEvents, opt, selected, toggleOption }">
            <q-item v-bind="itemProps" v-on="itemEvents">
              <q-item-section>
                <q-item-label v-html="opt.label"></q-item-label>
              </q-item-section>
              <q-item-section side>
                <q-toggle :value="selected" @input="toggleOption(opt)" />
              </q-item-section>
            </q-item>
          </template>
        </q-select>
      </template>

      <template v-slot:body-cell-ctr="props">
        <q-td :props="props">
          {{ `${props.row.ctr}%` }}
        </q-td>
      </template>

      <template v-slot:body-cell-scr="props">
        <q-td :props="props">
          {{ `${props.row.scr}%` }}
        </q-td>
      </template>

      <template v-slot:body-cell-lcr="props">
        <q-td :props="props">
          {{ `${props.row.lcr}%` }}
        </q-td>
      </template>

      <template v-slot:body-cell-transaction_amount_pending="props">
        <q-td :props="props">
          {{
            parseFloat(props.row.transaction_amount_pending).toLocaleString('pt-BR', {
              style: 'currency',
              currency: 'BRL'
            })
          }}
        </q-td>
      </template>

      <template v-slot:body-cell-transaction_amount_approved="props">
        <q-td :props="props">
          {{
            parseFloat(props.row.transaction_amount_approved).toLocaleString('pt-BR', {
              style: 'currency',
              currency: 'BRL'
            })
          }}
        </q-td>
      </template>

      <template v-slot:body-cell-margin_cpc_pending="props">
        <q-td :props="props">
          {{
            parseFloat(props.row.margin_cpc_pending).toLocaleString('pt-BR', {
              style: 'currency',
              currency: 'BRL'
            })
          }}
        </q-td>
      </template>

      <template v-slot:body-cell-margin_cpc_approved="props">
        <q-td :props="props">
          {{
            parseFloat(props.row.margin_cpc_approved).toLocaleString('pt-BR', {
              style: 'currency',
              currency: 'BRL'
            })
          }}
        </q-td>
      </template>

      <template v-slot:body-cell-total_pending="props">
        <q-td :props="props">
          {{
            parseFloat(props.row.total_pending).toLocaleString('pt-BR', {
              style: 'currency',
              currency: 'BRL'
            })
          }}
        </q-td>
      </template>

      <template v-slot:body-cell-total_approved="props">
        <q-td :props="props">
          {{
            parseFloat(props.row.total_approved).toLocaleString('pt-BR', {
              style: 'currency',
              currency: 'BRL'
            })
          }}
        </q-td>
      </template>

      <template v-slot:bottom>
        <!-- <pagination-table-reports
                  @change="getClickReport"
                  :data="reqPagination"
                  :pagination="pagination"
                />
                 -->
        <q-toolbar class="bg-transparent" :class="!$q.dark.isActive ? 'text-dark' : 'text-white'">
          Total:{{ reqPagination.total }}
          <q-space />
          <q-pagination
            unelevated
            v-model="currentPage"
            color="primary"
            :max="reqPagination.last_page"
            :max-pages="6"
            boundary-numbers
            direction-links
          />
        </q-toolbar>
      </template>
    </q-table>
  </q-intersection>
</template>

<script>
import ReportMixin from '../../mixins/ReportMixin';

export default {
  name: 'ListClickReports',
  mixins: [ReportMixin],
  methods: {
    async exportClickReport() {
      let columnsCsv = this.columnsLocal.filter((item) => this.visibleColumns.includes(item.name));

      this.onLoading(true);
      try {
        const { data, status } = await this.$http.get(
          'redirect?app=report&path=/api/report/click_report_csv?' + this.filterReports
        );
        if (status === 200 || status === 201) {
          console.log(data);
          this.exportTableCsv(data, columnsCsv, 'click-reports');
          this.successNotify(this.$t('export_successfully'));
        }
      } catch (error) {
        if (error.response && error.response.status === 500)
          this.errorNotify(this.$t('problem_try_again_later'));
        else this.errorNotify(error);
      } finally {
        this.onLoading(false);
      }
    },

    async retrieveWithSorting() {
      if (!this.sorting.column) {
        this.errorNotify(this.$t('select_column_sort'));
        return;
      }
      let params = this.filterReports.split('%26');
      if (this.sorting.column != null) {
        let sortIndex = params.findIndex((param) => param.includes('sort'));
        sortIndex != -1
          ? (params[sortIndex] = `sort=${this.sorting.column.field}%7C${this.sorting.order}`)
          : params.push(` sort=${this.sorting.column.field}%7C${this.sorting.order}`);
      } else {
        params = params.filter((val) => !val.includes('sort'));
      }
      this.ActionSetFilterReports(params.join('%26'));
      this.getConsolidatedClickReport();
    }
  },
  created() {
    this.ActionSetFilterReports();
    this.ActionSetReports();
    this.visibleColumns = this.columnsLocal.filter((column) => column.default !== false).map((column) => column.name);
  },

  watch: {
    currentPage() {
      if (this.reqPagination.from != this.reqPagination.current_page) {
        this.getConsolidatedClickReport(`%26page=${this.currentPage}`, `per_page=${this.pagination.rowsPerPage}`);
      }
    }
  },

  data() {
    return {
      visibleColumns: null,
      sorting: {
        column: null,
        order: 'asc'
      },
      columnsLocal: [
        {
          name: 'indice',
          label: this.$t('index'),
          align: 'left',
          field: (row) => (row.indice ? row.indice : row.indice_alternative),
          default: true
        },
        {
          name: 'impressions',
          label: this.$t('impressions'),
          align: 'left',
          field: 'impressions',
          default: true
        },
        {
          name: 'total_clicks',
          label: this.$t('total_clicks'),
          align: 'left',
          field: 'total_clicks',
          default: true
        },
        {
          name: 'unique_clicks',
          label: this.$t('single_clicks'),
          align: 'left',
          field: 'unique_clicks',
          default: true
        },
        {
          name: 'ctr',
          label: 'CTR %',
          align: 'left',
          field: 'ctr',
          default: false
        },
        {
          name: 'pending_leads',
          label: this.$t('pending_leads'),
          align: 'left',
          field: 'pending_leads',
          default: true
        },
        {
          name: 'approved_leads',
          label: this.$t('approved_leads'),
          align: 'left',
          field: 'approved_leads',
          default: false
        },
        {
          name: 'lcr',
          label: 'LCR %',
          align: 'left',
          field: 'lcr',
          default: false
        },
        {
          name: 'pending_sales',
          label: this.$t('pending_sales'),
          align: 'left',
          field: 'pending_sales',
          default: true
        },
        {
          name: 'approved_sales',
          label: this.$t('approved_sales'),
          align: 'left',
          field: 'approved_sales',
          default: false
        },
        {
          name: 'scr',
          label: 'SCR %',
          align: 'left',
          field: 'scr',
          default: false
        },
        {
          name: 'transaction_amount_pending',
          label: this.$t('transaction_amount_pending'),
          align: 'left',
          field: 'transaction_amount_pending',
          default: false
        },
        {
          name: 'transaction_amount_approved',
          label: this.$t('transaction_amount_approved'),
          align: 'left',
          field: 'transaction_amount_approved',
          default: false
        },
        {
          name: 'margin_cpc_pending',
          label: this.$t('cost_cpc_pending'),
          align: 'left',
          field: 'margin_cpc_pending',
          default: false
        },
        {
          name: 'margin_cpc_approved',
          label: this.$t('cost_cpc_approved'),
          align: 'left',
          field: 'margin_cpc_approved',
          default: false
        },
        {
          name: 'total_pending',
          label: this.$t('cost_pending'),
          align: 'left',
          field: 'total_pending',
          default: true
        },
        {
          name: 'total_approved',
          label: this.$t('cost_approved'),
          align: 'left',
          field: 'total_approved',
          default: true
        }
      ],
      pagination: {
        sortBy: 'created_at',
        descending: true,
        rowsPerPage: 10
      }
    };
  },

  computed: {
    currentPage: {
      get() {
        return this.reqPagination.current_page;
      },
      set(value) {
        this.ActionSetPagination({
          ...this.reqPagination,
          current_page: value
        });
      }
    },
    show() {
      return typeof this.reports === 'undefined' ? false : true;
    }
  }
};
</script>
